import { render, staticRenderFns } from "./DashboardEdit.vue?vue&type=template&id=d35f87f8&scoped=true"
import script from "./DashboardEdit.vue?vue&type=script&lang=js"
export * from "./DashboardEdit.vue?vue&type=script&lang=js"
import style0 from "./DashboardEdit.vue?vue&type=style&index=0&id=d35f87f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35f87f8",
  null
  
)

export default component.exports